export enum PlaningViewsEnum {
  lodging = 'lodging',
  rental = 'rental',
  lessons = 'lessons',
  flights = 'flights',
  carRental = 'carRental',
}

export const defaultLodgingRooms = 1;
export const defaultLodgingAdults = 2;
export const defaultSkiRentalChildren = 1;
export const defaultSkiRentalAdults = 1;
